export const Listdata = (flujax) => ({
  async getDataLens (dataLens) {
    return flujax.post('listdata/view/lens/get', dataLens)
  },

  async setDataLens (dataLens) {
    return flujax.post('listdata/view/lens/set', dataLens)
  },

  async getAllDataLenses () {
    return flujax.get('listdata/view/lens/getAll')
  },

  async promoteDraft (dataLens) {
    return flujax.post('listdata/view/lens/promote', dataLens)
  },

  async matchName (name, accountPlanId) {
    return flujax.post('listdata/view/lens/name/match', { name, accountPlanId })
  }
})
